export default __webpack_public_path__ + "static/bc_hu_4-d213a7f90619199b233abeadbdf7f27e.mp4";